import moment from 'moment-timezone';
import { useEffect, useReducer } from 'react';
import { setDefaultTimezone } from './utils';

export function useBrowserTimezoneAfterHydration(ssrTimezone?: string) {
  const [, rerender] = useReducer((version) => version + 1, 0);

  useEffect(() => {
    if (!ssrTimezone) {
      return;
    }

    const browserTimezone = moment.tz.guess();
    if (browserTimezone === ssrTimezone) {
      return;
    }

    setDefaultTimezone(browserTimezone);
    rerender();
  }, [ssrTimezone]);
}
